<template>
  <div class="main-inner-blk">
    <v-card class="trip-filter-blk" elevation="3">
      <Filters :dateRange="true" :filterData="'trips'" @get-filter="getFilters" :placeHolder="'Search ID/User'"></Filters>
    </v-card>

    <div class="trip-list-blk" :class="{'no-trip-blk':tripList.length === 0}">
      <div v-if="tripList.length > 0">
        <div class="trip-list-content">
<!--          <span class="info-blk"><i class="fas fa-exclamation-circle"></i> Started and Ended Trips are shown in the list</span>-->
          <span class="ended-length-blk">Ended Trips: {{endedTripCount}}</span>
          <span class="started-length-blk">Started Trips: {{startedTripCount}}</span>
          <span class="trip-length-blk">Total Trips: {{totalCount}}</span>
        </div>
        <TripsView :tripList="tripList"></TripsView>
      </div>
      <div class="no-trip-blk" v-if="tripList.length === 0">
        <span>No Trips to Show</span>
      </div>
    </div>
    <div class="pagination-blk" v-if="totalPages > 1">
      <v-pagination v-model="page" :length="totalPages" @input="onPageChange" color="#eea004"></v-pagination>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import Filters from "@/components/common/filter/Filters";
import TripsView from "@/components/Trips/trips-view/TripsView";
import axios from "@/axios/axios-global";
import Loading from "@/components/common/Loading";
import * as moment from "moment";

export default {
  name: "TripList",
  components: {Loading, TripsView, Filters},
  data: () => {
    return {
      tripList: [],

      loading: false,

      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),

      startedTripCount: 0,
      endedTripCount: 0,

      page: 1,
      totalCount: 0,
      perPage: 10,
      lastFilters: {},
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.perPage)
    }
  },
  mounted() {

    this.lastFilters = {start: this.startDate, end: this.endDate}
    this.getData(this.lastFilters)
  },
  methods: {
    async getData(data) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.startedTripCount = 0
        this.endedTripCount = 0
        this.loading = true
        const response = await axios.post('/backend/tripList', {start: data.start, end: data.end, search: data.search, page: this.page, limit: this.perPage})
        this.loading = false
        this.totalCount = response.data.count
        this.tripList = response.data.list || []
        this.tripList.forEach(data => {
          if (data.status.id === 7 || data.status.id === 8) {
            this.startedTripCount += 1
          } else if (data.status.id === 10 || data.status.id === 9) {
            this.endedTripCount += 1
          }
        })
      },500)
    },
    onPageChange(page) {
      this.page = page
      this.getData(this.lastFilters)
    },
    getFilters(data) {
      this.page = 1
      this.lastFilters = {start: data.start, end: data.end, search: data.searchValue}
      this.getData(this.lastFilters)
    }
  }
}
</script>

<style scoped lang="scss">
@import "./tripList";
.pagination-blk {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  background-color: white;
  padding: 6px 0;
  z-index: 2;
  border-top: 1px solid #e0e0e0;
}
</style>